import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DeleteCategoryModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteCategoryModalContainer" */
      './DeleteCategoryModalContainer'
    ),
  loading: LoadingModal,
});
